import { useEffect, useState } from "react";
import {
    alpha,
    Button,
    CircularProgress,
    Paper,
    Stack,
    TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../components/Popup";
import { addStuff } from "../../redux/userRelated/userHandle";
import {
    StudentPageContainer,
    StudentPageHeader,
} from "./studentPortalUi";

const StudentComplain = () => {
    const [complaint, setComplaint] = useState("");
    const [date, setDate] = useState("");
    const dispatch = useDispatch();
    const { status, currentUser, error } = useSelector((state) => state.user);

    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const fields = {
        user: currentUser?._id,
        date,
        complaint,
        school: currentUser?.school?._id,
    };

    const submitHandler = (event) => {
        event.preventDefault();
        setLoader(true);
        dispatch(addStuff(fields, "Complain"));
    };

    useEffect(() => {
        if (status === "added") {
            setLoader(false);
            setShowPopup(true);
            setMessage("Your complaint was submitted successfully.");
            setComplaint("");
            setDate("");
        } else if (error) {
            setLoader(false);
            setShowPopup(true);
            setMessage("Could not submit. Please try again.");
        }
    }, [status, error]);

    return (
        <StudentPageContainer maxWidth="sm">
            <StudentPageHeader
                eyebrow="Support"
                title="Submit a complaint"
                subtitle="Send a message to your school administration. Include the date and a clear description."
            />

            <Paper
                elevation={0}
                component="form"
                onSubmit={submitHandler}
                sx={{
                    p: { xs: 2.5, sm: 3 },
                    borderRadius: 3,
                    border: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
                }}
            >
                <Stack spacing={2.5}>
                    <TextField
                        fullWidth
                        label="Date of incident"
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        fullWidth
                        label="Your message"
                        value={complaint}
                        onChange={(e) => setComplaint(e.target.value)}
                        required
                        multiline
                        minRows={4}
                        placeholder="Describe what happened and what you need from the school..."
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={loader}
                        sx={{ fontWeight: 700, borderRadius: 2 }}
                    >
                        {loader ? <CircularProgress size={24} color="inherit" /> : "Submit complaint"}
                    </Button>
                </Stack>
            </Paper>

            <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} severity="success" />
        </StudentPageContainer>
    );
};

export default StudentComplain;
